import { render } from "./richtext-entry.vue?vue&type=template&id=061b7195"
import script from "./richtext-entry.vue?vue&type=script&lang=js"
export * from "./richtext-entry.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__